import React from 'react';
import { AgentSlideForm } from './AgentSlideForm';
import { QueueSlideForm } from './QueueSlideForm';

type Row = {
  type: 'agent' | 'queue';
  // [key: string]: any;
};

type Props = {
  index: number;
  rows: Row[];
  data: Record<string, any>;
};

export const LeaderboardSlideForm = ({ index, rows, data }: Props) => {
  return rows?.[index]?.type === 'agent' ? (
    <AgentSlideForm props={data} />
  ) : (
    <QueueSlideForm props={data} />
  );
};
